import { memo } from 'react';

import { Stack, Typography } from '@lyearn/ui';
import SkillPill, { SkillPillProps } from '@/modules/corporate/components/SkillPill';
import { Maybe } from '@/types/schema';

interface SkillProps {
  className?: string;
  skills: Maybe<SkillPillProps['skill'][]> | undefined;
  title: string;
}

const Skills: React.FC<SkillProps> = ({ skills, className, title }) => {
  if (!skills?.length) {
    return null;
  }

  return (
    <Stack className={className} direction="col">
      <Typography as="h2" className="ms-4" variant="heading-m">
        {title}
      </Typography>
      <Stack className="mt-24 flex-wrap" gap={8}>
        {skills.map((skill) => (
          <SkillPill key={skill.id} skill={skill} />
        ))}
      </Stack>
    </Stack>
  );
};

export default memo(Skills);
